import fetch from "../utils/fetch";

const baseUrl = "/dataApi";

// 警戒监测列表
export function getMonitorList(data) {
  return fetch({
    url: baseUrl + "/api/AlertMonitoring/SelectAlertMonitoringInfo",
    method: "get",
    params: data,
  });
}
// 警戒监测-报告网站列表
export function getMonitorOptions(data) {
  return fetch({
    url:  baseUrl + "/api/AlertMonitoring/GetSelectItem",
    method: "get",
    params: data,
  });
}

